import { HttpErrorResponse } from '@angular/common/http';
import { ErrorModel } from '../models/error-model.interface';

function resolveErrorI18nKey(error: unknown): string | null {
  if (!(error instanceof HttpErrorResponse)) {
    return null;
  }

  const errorModel = error.error as ErrorModel | null;
  const rawKey = errorModel?.i18nKey?.trim();
  if (!rawKey) {
    return null;
  }

  return rawKey.toUpperCase();
}

export function isConcurrencyConflictError(error: unknown): boolean {
  if (error instanceof HttpErrorResponse && error.status === 409) {
    return true;
  }

  return resolveErrorI18nKey(error) === 'CONCURRENCYCONFLICT';
}
